import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-video.css";
import "lightgallery/css/lg-transitions.css";

import lightGallery from "lightgallery";
import lgVideo from "lightgallery/plugins/video";
import lgZoom from "lightgallery/plugins/zoom";
import lgThumbnail from "lightgallery/plugins/thumbnail";

document.querySelectorAll("[data-lg-video-after-click]")?.forEach((el) => {
	lightGallery(el, {
		selector: "this",
		plugins: [lgVideo],
		licenseKey: "0D0A7BAD-63644EDA-8ADD2380-F0EEFDEE",
	});
});

document.querySelectorAll("[data-lg-gallery-thumbnail]")?.forEach((el) => {
	const gallery = lightGallery(
		el.querySelector("[data-lg-gallery-thumbnail-wrap]"),
		{
			plugins: [lgZoom, lgThumbnail],
			zoom: true,
			thumbnail: true,
			licenseKey: "0D0A7BAD-63644EDA-8ADD2380-F0EEFDEE",
			mobileSettings: { showCloseIcon: true, download: true },
		}
	);
	el.querySelectorAll("[data-lg-gallery-thumbnail-start]").forEach(
		(btn, index) => {
			btn.addEventListener("click", (e) => {
				gallery.openGallery(index);
			});
		}
	);
});

document.querySelectorAll(".youtube-video-gallery")?.forEach((el) =>
	lightGallery(el, {
		selector: ".youtube-video-gallery-item",
		plugins: [lgVideo],
		licenseKey: "0D0A7BAD-63644EDA-8ADD2380-F0EEFDEE",
		autoplayFirstVideo: true,
	})
);

document.querySelectorAll(".photo-gallery")?.forEach((el) => lightGallery(el));
